import React from 'react'

export const SendIcon = ({ fill = 'white', size = '16' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.83992 14L15.8333 8L1.83992 2L1.83325 6.66667L11.8333 8L1.83325 9.33333L1.83992 14Z"
        fill={fill}
      />
    </svg>
  )
}
